<template>
  <div>
    <div>
      <p>
        {{this.selectedCategoryArticles.length}}
        <LabelFunMessage fcontId="0" msgkey="63" />
      </p>
    </div>

    <transition-group name="articles" tag="div" class="row flex">
      <div
        class="col col-xxs-6 col-xs-6 col-sm-6 col-md-3 article-item"
        v-bind:key="article.id"
        v-for="(article, index) in selectedCategoryArticles"
      >
        <a
          v-on:click="clickLink(article.id, index)"
        >
          <div class="thumbnail new-thumbnail">
            <img
              v-bind:src="app_root + '/assets/article' + article.id + '/images/i7_small.jpg'"
              alt="..."
              class="lazyload"
            />
            <div class="caption"
            v-bind:class="'caption_' + selectedCategoryTitle">
              <h3 class="thum_title items" ref="items">
                <LabelFunMessage :fcontId="article.id.toString()" msgkey="1" />
              </h3>
              <p class="des_funcontents">
                <LabelFunMessage :fcontId="article.id.toString()" msgkey="2" />
              </p>
              <p v-if="isShowReleaseDate" class="release_date">
                {{releaseDateString(article.releaseDate)}}
              </p>
            </div>
            <img v-if="article.isNew" :src="app_root + '/assets/common/img/new_label.svg'" class="new_label" />
          </div>
        </a>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import { localeDateString } from "@/common/localedate";

const SPECIAL_EDITIONS_CATEGORYID = 1;

export default {
  name: "CategoryContents",
  props: {
    selectedCategoryId: Number,
  },
  components: {
    LabelFunMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState(["lg2"]),
    ...mapGetters(["getArticlesForMuuri","getCategories"]),

    selectedCategoryArticles: function () {
      if (this.getArticlesForMuuri == []) {
        return [];
      } else {
        let categoryArticles = this.getArticlesForMuuri.filter(
          function (article) {
            let category = article.categories.find(
              function (category) {
                return category.categoryId == this.selectedCategoryId;
              }.bind(this)
            );
            if (category === undefined) {
              return false;
            } else {
              return true;
            }
          }.bind(this)
        );
        // priorityが降順になるようにソート
        categoryArticles = categoryArticles.sort((a, b) =>{
          const aCategory = a.categories.find( function (category) {
            if(category.categoryId == this.selectedCategoryId) {
              return category.priority
            }
          }.bind(this))
          const bCategory = b.categories.find( function (category) {
            if(category.categoryId == this.selectedCategoryId) {
              return category.priority
            }
          }.bind(this))
          return (bCategory.priority - aCategory.priority)
        })
        return categoryArticles;
      }
    },

    selectedCategoryTitle: function () {
      if (this.getCategories == []) {
        return "";
      } else {
        const category = this.getCategories.find(
          function (category) {
            return category.id == this.selectedCategoryId;
          }.bind(this)
        );
        if (category === undefined) {
          return "";
        } else {
          return category.title;
        }
      }
    },
    isShowReleaseDate: function () {
      return this.selectedCategoryId == SPECIAL_EDITIONS_CATEGORYID;
    }
  },
  methods: {
    clickLink: function (id, index) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "category_articles",
        "custom_parameter2": this.selectedCategoryTitle,
        "custom_parameter3": `${index+1}`,
        "custom_parameter4": `${id}`
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/articles/' + id,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
       })
    },
    articlePriority: function (article) {
      let category = article.categories.find(
        function (category) {
          return category.categoryId == this.selectedCategoryId;
        }.bind(this)
      );
      if (category === undefined) {
        return 0;
      } else {
        return category.priority;
      }
    },
    releaseDateString: function(date) {
      return localeDateString(date, this.$store.state.lg2)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.flex::before,
.row::after {
  display: none;
}

.flex .col {
  padding-bottom: 20px;
}

.article-item {
  display: inline-block;
  transition: opacity 0.3s;
  transition: transform 0.5s;
}

.thumbnail {
  height: 100%;
  margin-bottom: 0px;
}

.thumbnail .caption_special-editions {
  padding-bottom: 25px;
}

.release_date {
  position: absolute;
  right: 4px;
  bottom: 0;
  text-align: right; 
  font-size: 11px; 
  color: #8d8d8d;
}

/* アニメーション */
.articles-leave-active {
  position: absolute;
}

.articles-enter,
.articles-leave-to {
  opacity: 0;
  transform: scale(0.5);
}

.articles-enter-to,
.articles-leave {
  opacity: 1;
  transform: scale(1);
}

@media (max-width: 767px) {
  .flex .col {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .thumbnail .caption_special-editions {
    padding-bottom: 25px;
  }

  .release_date {
    margin-bottom: 4px;
    right: 2px;
    font-size: 10px; 
  }
}

@supports (-ms-ime-align: auto) {
  /* Edge のみ適用される */
  .article-item {
    transition: 0.01s
  }
}
</style>